import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/** Newest-first page of mobile-app error reports (crash dashboard). */
export const useMobileAppErrors = ({ page = 1, rows = 20 } = {}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["mobileAppErrors", tenantVal, page, rows],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/mobileapp/error/page`,
        { params: { page, rows } }
      );
      return response.data;
    },
    enabled: !!tenantVal,
  });
};
